import { BeamClient, beamProviderInfo } from '@onbeam/sdk';
import { config } from './config';

const beamClient = new BeamClient(config);

const beamProvider = beamClient.connectProvider();

export { beamClient, beamProvider, beamProviderInfo };
